import React from "react";
import Avatar from "./Avatar";
import ProfileIdentity from "./ProfileIdentity";
import ProfileGroupLink from "./ProfileGroupLink";
import ProfileBio from "./ProfileBio";
import SocialLinks from "./SocialLinks";
import ProfileMenu from "./ProfileMenu";

function ProfileCard({ user, company, socialLinks, menuItems }) {
  return (
    <article className="profile-card">
      <Avatar src={user.avatar} alt={user.avatarAlt} isOnline={user.isOnline} />
      <div className="profile-card__main">
        <ProfileIdentity
          name={user.name}
          isOnline={user.isOnline}
          lastSeen={user.lastSeen}
        />
        {company && <ProfileGroupLink group={company} />}
        <ProfileBio text={user.bio} />
        <SocialLinks items={socialLinks} />
      </div>
      <ProfileMenu items={menuItems} />
    </article>
  );
}

export default ProfileCard;
